var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('Banner'),_c('Guarantees'),_c('Banks'),_c('Accreditation'),_c('BecomeAnAgent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }